import { Card } from './Card';
import { VStack, Heading, Text, type BoxProps } from '@chakra-ui/react';
import { PROFILE_SECTION_BODY_SPACING, PROFILE_SECTION_HEADING_PROPS } from './profileSectionStyles';

export function PointsUpdatingCard(props: Omit<BoxProps, 'children'> & { compact?: boolean }) {
  const { compact = false, ...cardProps } = props;

  return (
    <Card
      overflowY='unset'
      w='full'
      h='auto'
      height='unset'
      flexShrink={0}
      borderRadius={compact ? 0 : undefined}
      {...cardProps}
    >
      <VStack spacing={PROFILE_SECTION_BODY_SPACING} align='center' w='full'>
        <Heading {...PROFILE_SECTION_HEADING_PROPS} textAlign='center'>
          Updating
        </Heading>
        <Heading fontSize='lg' fontWeight='semibold' lineHeight='short' textAlign='center'>
          Points and rankings are now updating
        </Heading>
        <Text fontSize='sm' textAlign='center'>
          Please check again later.
        </Text>
      </VStack>
    </Card>
  );
}
